import Ajax from "Utils/ajax";
export const getStaffList = (data) => Ajax.post('hr/getStaffList',data); 
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const getStaffAttendance = (data) => Ajax.post('hr/getStaffAttendance',data);
export const getStaffShiftHistory = (data) => Ajax.post('hr/getStaffShiftHistory',data);
export const getSubordinatesAttendance = (data) => Ajax.post('hr/getSubordinatesAttendance',data);
export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data); 
export const getStaffAttendanceByDate = (data) => Ajax.post('hr/getStaffAttendanceByDate',data);
export const getStaffAttendanceDataForUpdate = (data) => Ajax.post('hr/getStaffAttendanceDataForUpdate',data);